import { ClientState } from "@/@types/vuex";

export default {
  clients: {},
} as ClientState;
